import React from 'react';
import socketio from 'socket.io-client';
import { SOCKET_URL } from '../config';

const accessToken = window.localStorage.getItem('accessToken');

// Reconnection strategy (part 1/2):
// - Built-in Socket.IO retry (using library defaults) covers transient
//   network/transport failures.
// - A second/manual path for `io server disconnect` is implemented in JWTContext,
//   because Socket.IO does not auto-reconnect that case by default.
export const socket = socketio.connect(`${SOCKET_URL}`, {
  autoConnect: false,
  auth: { token: accessToken },
  withCredentials: true,
});

export const SocketContext = React.createContext();
